<template>
  <div>
    <v-container
        fluid
        grid-list-lg>
        <v-layout row wrap>
          <v-flex md4>
            <v-card>
              <v-card-title primary-title>
                <v-container fluid class="pa-0">
                  <v-layout row wrap>
                    <v-flex md12 lg12 style="display: flex; justify-content: center; align-items: center;">
                      <v-avatar size="160" color="grey lighten-2" style="flex: 0;">
                        <v-icon size="140" color="pink lighten-2">pregnant_woman</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex md12 lg12>
                      <v-list>
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-icon>person</v-icon>
                          </v-list-tile-action>

                          <v-list-tile-content>
                            <v-list-tile-title :title="study.patientName">{{study.patientName}}</v-list-tile-title>
                            <small>{{ study.patId }}</small>
                          </v-list-tile-content>
                        </v-list-tile>

                        <v-divider inset></v-divider>

                        <v-list-tile>
                          <v-list-tile-action>
                            <v-icon>cake</v-icon>
                          </v-list-tile-action>

                          <v-list-tile-content>
                            <v-list-tile-title> {{study.birthDate | formatDate}} <small>({{study.birthDate | ageFriendly}})</small></v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>

                        <v-divider inset></v-divider>

                        <v-list-tile>
                          <v-list-tile-action>
                            <v-icon>phone</v-icon>
                          </v-list-tile-action>

                          <v-list-tile-content>
                            <v-list-tile-title :title="study.phone | phone">{{study.phone | phone}}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>

                        <v-divider inset></v-divider>

                        <v-list-tile>
                          <v-list-tile-action>
                            <v-icon>email</v-icon>
                          </v-list-tile-action>

                          <v-list-tile-content>
                            <v-list-tile-title :title="study.email">{{study.email}}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>

                        <v-divider inset></v-divider>

                        <v-list-tile>
                          <v-list-tile-action>
                            <v-icon>event</v-icon>
                          </v-list-tile-action>

                          <v-list-tile-content>
                            <v-list-tile-title> {{study.serviceDate | formatDate}} </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>

                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-title>
              <v-card-actions>
                <!--<v-btn flat color="red">Laudo</v-btn>-->
                <v-btn flat color="red" @click="$router.push(reportPath())">UltraFetal</v-btn>
                <!--<v-btn flat color="red">WhatsApp</v-btn>-->
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex md8>
            <v-layout row wrap>
              <v-flex xs12 v-for="item in studies" :key="item.id">
                <v-card>
                  <v-container fluid>
                    <v-layout row wrap>
                      <v-flex md12 lg12>
                        <div class="subheading">{{ item.accessionNo }} - {{ item.title }}</div>
                        <div class="caption">{{study.serviceDate | formatDateTime}} | Dr(a). {{ item.resource }} - {{ item.room }}</div>
                      </v-flex>
                      <v-flex xs12 v-if="item.pathVideo !== null">
                        <iframe
                          :src="video(item)"
                          width="100%"
                          height="300px"
                          style="border: 0px"
                          allowfullscreen="allowfullscreen"
                          mozallowfullscreen="mozallowfullscreen"
                          msallowfullscreen="msallowfullscreen"
                          oallowfullscreen="oallowfullscreen"
                          webkitallowfullscreen="webkitallowfullscreen"/>
                      </v-flex>
                      <v-flex
                        v-for="(image, i) in item.imagesURL"
                        :key="image"
                        xs4>
                        <v-card flat tile>
                          <v-img
                            :src="image"
                            :lazy-src="`${image}&rows=50`"
                            @click="slideIndex = i"
                            style="background-color: black; height: 150px;">
                             <v-layout
                                slot="placeholder"
                                fill-height
                                align-center
                                justify-center
                                ma-0>
                                <v-progress-circular indeterminate color="grey lighten-5"/>
                              </v-layout>
                          </v-img>
                        </v-card>
                      </v-flex>
                      <vue-gallery :images="item.imagesURL" :index="slideIndex" @close="slideIndex = null"></vue-gallery>
                    </v-layout>
                    <!--<v-layout row wrap v-else>-->
                      <!--<v-flex md12 lg12 style="display: flex; justify-content: center; align-items: center;">-->
                        <!--<v-icon size="140" color="primary lighten-1">image</v-icon>-->
                      <!--</v-flex>-->
                      <!--<v-flex md12 lg12 style="display: flex; justify-content: center; align-items: center;">-->
                        <!--Nenhuma imagem ou video foi encontrado-->
                      <!--</v-flex>-->
                    <!--</v-layout>-->
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import VueGallery from 'vue-gallery'
import { mapState } from 'vuex'
import { formatWadoRsToWado } from '../utils/dicom'

export default {
  name: 'Study',
  components: {
    VueGallery
  },
  props: {
    id: {
      required: false
    },
    patId: {
      required: false
    },
    serviceDate: {
      required: false
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      company: (state) => state.company
    }),
    study () {
      return this.studies[0]
    }
  },
  data () {
    return {
      msg: 'Study',
      loading: true,
      studies: [{}],
      slideIndex: null
    }
  },
  async mounted () {
    this.id ? await this.find() : await this.findByPatIdAndServiceDate()
    this.loading = false
    this.findImages()
  },
  methods: {
    reportPath () {
      return `/reports/${this.studies[0].patId}/${this.studies[0].serviceDate}`
    },
    find () {
      return axios.get(`https://www.ultravideo.com.br/companies/${this.company}/studies/${this.id}`)
      .then(res => {
        this.studies = [ res.data ]
      })
      .catch(err => {
        this.studies = [ {} ]
        console.error(err)
      })
    },
    findByPatIdAndServiceDate () {
      console.log(this.serviceDate)
      let serviceDay = moment(this.serviceDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
      return axios.get(`https://www.ultravideo.com.br/companies/${this.company}/studies?patId=${this.patId}&serviceDay=${serviceDay}`)
      .then(res => {
        this.studies = res.data.list.sort((a, b) => { return (a.pathVideo + a.accessionNo).localeCompare(b.pathVideo + b.accessionNo) })
      })
      .catch(err => {
        this.studies = [ {} ]
        console.log(err)
      })
    },
    findImages () {
      const vm = this
      this.studies.forEach((item, index) => {
        // const studyUid = item.studyUid.replace(/\./g, '-')
        // const studyUid = '1-2-826-0-1-3680043-9-3782-82106659000191-746395'
        axios.get(`https://daascloud.com.br:8443/dcm4chee-arc/aets/DCM4CHEE/rs/studies/${item.studyUid}/metadata`)
          .then(async res => {
            const data = res.data
            vm.$set(vm.studies[index], 'images', data)
            vm.$set(vm.studies[index], 'imagesURL', vm.mountImagesURL(data))
          })
          .catch(err => {
            item.images = {}
            item.imagesURL = []
            console.log(err)
          })
      })
    },
    mountImagesURL (images) {
      const urls = []
      images.forEach(item => urls.push(formatWadoRsToWado(item['7FE00010'].BulkDataURI, true)))
      return urls
    },
    video (study) {
      if (!study.pathVideo) return null
      return `https://www.ultravideo.com.br/player/${study.hashKey}`
    }
  }
}
</script>

<style scoped>
  .blueimp-gallery-display {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Study.vue